// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"48fa466c","121":"9fb7f0df","259":"f680ff88","357":"d5b788e3","435":"5c88d503","436":"fa9007e5","570":"65c28f87","858":"281ee0d1"}[chunkId] + ".chunk.js";
};